import { InputContainer } from "./style";
import { InputSearchProps } from "./types";

export function InputSearch(props: InputSearchProps){
  return (
    <InputContainer {...props} onChange={props.onChange} />
  )
}
